export const getBlockRouting = (state) => state.redirect.blockRouting;
export const getShowConfirmationDialog = (state) => state.redirect.showConfirmationDialog;
export const getUserConfirmed = (state) => state.redirect.userConfirmed;
